// extracted by mini-css-extract-plugin
module.exports = {"rentRoomContainer":"RentRoomList_rentRoomContainer__6FMk1","extraButtonList":"RentRoomList_extraButtonList__301Ey"};